/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect, useState, Dispatch} from 'react'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import * as actions from '../../../../setup/redux/auth/actions'
import './company-switch.scss'
import {SearchComponent} from '../../../../app/services/table/SearchComponent'
import {setActiveCompany} from '../../../../setup/redux/auth/slices'
import {useNavigate} from 'react-router-dom'
import {
  checkUpgradePaymentRequired,
  isCompanyDisabled,
  isCompanyGracePeriodExpired,
  isUserInactive,
  isUserRoleDisabled,
  paymentLink,
} from '../../../../app/services/Functional'
import {endCall} from '../../../../setup/redux/common/slices'

const CompanySwitchMenu: FC = () => {
  const navigate = useNavigate()
  const dispatch: Dispatch<any> = useDispatch()
  const {inspectionCompanies, active_inspection_company, user}: any = useSelector<RootState>(
    (state) => ({
      user: state.auth.user,
      inspectionCompanies: state.auth.inspection_companies,
      active_inspection_company: state.auth.active_inspection_company,
    }),
    shallowEqual
  )

  const [searchTerm, setSearchTerm] = useState<string>('')

  useEffect(() => {
    dispatch(actions.getInspectionCompanies())
  }, [])

  const filteredCompanies = inspectionCompanies.filter((company: any) => {
    const companyName = company.name ? String(company.name) : ''
    const searchValue = searchTerm ? String(searchTerm.search) : ''

    return companyName
      .replace(/_|\s/g, '')
      .toLowerCase()
      .includes(searchValue.replace(/_|\s/g, '').toLowerCase())
  })

  const reorderedCompanies = (() => {
    const firstCompany = filteredCompanies[0] || null
    const activeCompany = filteredCompanies.find(
      (company: any) => company.id === active_inspection_company?.id
    )
    const remainingCompanies = filteredCompanies.filter(
      (company: any) => company.id !== firstCompany?.id && company.id !== activeCompany?.id
    )

    const result = []
    if (firstCompany) result.push(firstCompany)
    if (activeCompany && activeCompany.id !== firstCompany?.id) result.push(activeCompany)
    return result.concat(remainingCompanies)
  })()

  const handleSwitchCompany = async (selectedCompany: any) => {
    if (user.is_root) {
      dispatch(setActiveCompany(selectedCompany))
      return setTimeout(() => {
        window.location.href = '/'
      }, 100)
    }

    const groupIds = selectedCompany.groups.map((group: any) => group.slug)

    if (!groupIds.includes('company-admins')) {
      return navigate('/error/auth')
    }

    const {plans, is_expired} = selectedCompany
    const {subscription, payment_status, subscription_type, reference_id} = plans[0]
    const isExpiredGracePeriodCompany = isCompanyGracePeriodExpired(selectedCompany)

    if (subscription.type === 'paid' && payment_status === 'pending') {
      const redirectPaymentUrl = subscription.payment_link[subscription_type] || ''
      return (window.location.href = paymentLink(redirectPaymentUrl, user.email, reference_id))
    }

    if (
      isExpiredGracePeriodCompany &&
      ((subscription.type === 'paid' && is_expired) || (subscription.type === 'free' && is_expired))
    ) {
      const expiryData: any = await dispatch(actions.checkSubscriptionExpiry(selectedCompany.id))
      if (expiryData?.data?.inspection_company && expiryData.data.inspection_company <= 0) {
        const upgradePaymentData = checkUpgradePaymentRequired(selectedCompany)
        if (upgradePaymentData.required) {
          dispatch(endCall({}))
          return (window.location.href = upgradePaymentData.link!)
        } else {
          dispatch(endCall({}))
          dispatch(actions.handleExpiredCompany(selectedCompany))
          dispatch(actions.handleIsExpiredCompanyAPIcalling(true))
          return navigate('/error/access-denied')
        }
      }
    }

    dispatch(setActiveCompany(selectedCompany))
    return setTimeout(() => {
      window.location.href = '/'
    }, 100)
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold cs-menu-container fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='d-flex flex-column flex-gap-16'>
        <div className='d-flex flex-column flex-gap-8'>
          <div className='font-size-12 text-uppercase font-weight-bold line-height-20 text-soft-steel-gray'>
            Companies
          </div>
          <div className='cs-search'>
            <SearchComponent updateState={setSearchTerm} />
          </div>
        </div>
        <div className='com-list-container'>
          {reorderedCompanies &&
            reorderedCompanies.map((inspectionCompany: any, index: number) => (
              <React.Fragment key={index}>
                <li className='cs-form-check'>
                  <input
                    className={`cs-form-check-input cs-form-disabled-check-input`}
                    type='radio'
                    name='company'
                    id={`company-${index}`}
                    // disabled
                    value={inspectionCompany?.id}
                    checked={active_inspection_company?.id === inspectionCompany?.id}
                    onChange={() => handleSwitchCompany(inspectionCompany)}
                  />
                  <label
                    className={`cs-form-check-label  ${isCompanyDisabled(inspectionCompany) || !isUserRoleDisabled(inspectionCompany) || isUserInactive(inspectionCompany) ? 'disable-company-name-container' : ''} `}
                    htmlFor={`company-${index}`}
                  >
                    <span className='sw-com-name'>{inspectionCompany.name}</span>
                  </label>
                </li>
              </React.Fragment>
            ))}
          {reorderedCompanies?.length === 0 && (
            <div className='text-soft-steel-gray'>No companies found</div>
          )}
        </div>
      </div>
    </div>
  )
}

export {CompanySwitchMenu}
